import React from "react";
import "./Dropdown.css";

export default function Dropdown({ label, value, options, onChange }) {
  return (
    <div className="ci-dropdown">
      <label className="ci-dropdown-label">{label}</label>
      <select
        className="ci-dropdown-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((opt, index) => (
          <option key={index} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}